/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TableStructureControl } from "./TableStructureControl";
import {
  TableStructureControlFromJSON,
  TableStructureControlFromJSONTyped,
  TableStructureControlToJSON,
  TableStructureControlToJSONTyped,
} from "./TableStructureControl";

/**
 *
 * @export
 * @interface PaginatedTableStructureControlList
 */
export interface PaginatedTableStructureControlList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<TableStructureControl>;
}

/**
 * Check if a given object implements the PaginatedTableStructureControlList interface.
 */
export function instanceOfPaginatedTableStructureControlList(
  value: object
): value is PaginatedTableStructureControlList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedTableStructureControlListFromJSON(
  json: any
): PaginatedTableStructureControlList {
  return PaginatedTableStructureControlListFromJSONTyped(json, false);
}

export function PaginatedTableStructureControlListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedTableStructureControlList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(TableStructureControlFromJSON),
  };
}

export function PaginatedTableStructureControlListToJSON(
  json: any
): PaginatedTableStructureControlList {
  return PaginatedTableStructureControlListToJSONTyped(json, false);
}

export function PaginatedTableStructureControlListToJSONTyped(
  value?: PaginatedTableStructureControlList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(TableStructureControlToJSON),
  };
}
